import { render, staticRenderFns } from "./EducatorCreateTranslation.vue?vue&type=template&id=90140a56&"
import script from "./EducatorCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./EducatorCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./EducatorCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports